@if (loading && rows.length === 0) {
<div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
  @for (i of [1, 2, 3, 4, 5, 6]; track i) {
  <div class="animate-pulse rounded-2xl border border-gray-200 bg-white p-5 dark:border-[#191e3a] dark:bg-[#0e1726]">
    <div class="mb-4 h-5 w-2/3 rounded bg-gray-200 dark:bg-white/10"></div>
    <div class="mb-2 h-4 w-1/3 rounded bg-gray-200 dark:bg-white/10"></div>
    <div class="h-16 rounded bg-gray-100 dark:bg-white/5"></div>
  </div>
  }
</div>
} @else if (!loading && rows.length === 0) {
<div class="flex min-h-[220px] flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 px-6 py-12 text-center dark:border-[#191e3a]">
  <icon-inbox class="mb-3 size-10 text-gray-300 dark:text-gray-600" />
  <p class="text-sm text-gray-500 dark:text-gray-400">{{ emptyMessage }}</p>
</div>
} @else {
<div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
  @for (row of rows; track row.id; let i = $index) {
  <article
    class="group relative flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:border-gray-300 hover:shadow-md dark:border-[#191e3a] dark:bg-[#0e1726] dark:hover:border-white/20">
    <div class="mb-4 flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <h3 class="truncate text-base font-semibold text-[#18214d] dark:text-white">
          {{ row.subscription_name || 'Untitled plan' }}
        </h3>
        <div class="mt-2 flex flex-wrap items-center gap-2">
          <span class="inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
            [ngClass]="typeBadgeClass(row.subscription_type)">
            {{ row.subscription_type || 'STANDARD' }}
          </span>
          <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
            [ngClass]="statusBadgeClass(row)">
            {{ statusLabel(row) }}
          </span>
        </div>
      </div>

      <div class="agent-action-menu relative shrink-0">
        <button type="button"
          class="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/10"
          (click)="toggleMenu.emit({ key: actionMenuRowKey(i), event: $event })"
          [attr.aria-expanded]="openActionMenuKey === actionMenuRowKey(i)" aria-haspopup="menu"
          aria-label="Subscription actions">
          <icon-horizontal-dots class="size-5 rotate-90" />
        </button>
        @if (openActionMenuKey === actionMenuRowKey(i)) {
        <div appActionMenuPanel
          class="w-48 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg dark:border-[#191e3a] dark:bg-[#0e1726]"
          role="menu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          @if (view === 'active') {
            @if (P.SUBSCRIPTION_UPDATE | hasPermission) {
            <button type="button" role="menuitem"
              class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); edit.emit(row)">
              <icon-pencil class="size-4 shrink-0" />
              Edit
            </button>
            }
            @if (P.SUBSCRIPTION_DELETE | hasPermission) {
            <button type="button" role="menuitem"
              class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-danger/5"
              (click)="closeMenu.emit(); delete.emit(row)">
              <icon-trash class="size-4 shrink-0" />
              Delete
            </button>
            }
          } @else {
            @if (P.SUBSCRIPTION_RESTORE | hasPermission) {
            <button type="button" role="menuitem"
              class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); restore.emit(row)">
              <icon-restore class="size-4 shrink-0" />
              Restore
            </button>
            }
            @if (P.SUBSCRIPTION_DELETE | hasPermission) {
            <button type="button" role="menuitem"
              class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-danger/5"
              (click)="closeMenu.emit(); permanentDelete.emit(row)">
              <icon-trash class="size-4 shrink-0" />
              Delete permanently
            </button>
            }
          }
        </div>
        }
      </div>
    </div>

    <dl class="grid grid-cols-2 gap-3 text-sm">
      <div class="rounded-xl bg-gray-50 px-3 py-2.5 dark:bg-white/5">
        <dt class="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Price</dt>
        <dd class="mt-0.5 font-semibold text-[#18214d] dark:text-white">{{ formatPrice(row.subscription_price) }}</dd>
      </div>
      <div class="rounded-xl bg-gray-50 px-3 py-2.5 dark:bg-white/5">
        <dt class="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Validity</dt>
        <dd class="mt-0.5 font-semibold text-[#18214d] dark:text-white">
          {{ row.validity_days != null ? row.validity_days + ' days' : '—' }}
        </dd>
      </div>
      @if ((row.subscription_type || '').toUpperCase() === 'CUSTOM' && tenantLabels(row).length) {
      <div class="col-span-2 rounded-xl bg-gray-50 px-3 py-2.5 dark:bg-white/5">
        <dt class="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Clients</dt>
        <dd class="mt-1.5 flex max-h-20 flex-wrap gap-1.5 overflow-y-auto">
          @for (name of tenantLabels(row); track name) {
          <span
            class="inline-flex rounded-full bg-white px-2.5 py-0.5 text-xs font-medium text-[#18214d] ring-1 ring-gray-200 dark:bg-[#0e1726] dark:text-white dark:ring-[#191e3a]">
            {{ name }}
          </span>
          }
        </dd>
      </div>
      }
      @if (modelQuotaEntries(row).length > 0) {
      <div class="col-span-2 rounded-xl bg-gray-50 px-3 py-2.5 dark:bg-white/5">
        <dt class="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Models</dt>
        <dd class="mt-1.5 flex flex-wrap gap-1.5">
          @for (m of modelQuotaEntries(row); track m.label) {
          <span
            class="inline-flex items-center rounded-full bg-white px-2.5 py-0.5 text-xs font-medium text-[#18214d] ring-1 ring-gray-200 dark:bg-[#0e1726] dark:text-white dark:ring-[#191e3a]">
            {{ m.label }}
            <span class="font-semibold">{{ m.count }}</span>
          </span>
          }
        </dd>
      </div>
      }
    </dl>

    @if (view === 'deleted' && row.deleted_at) {
    <p class="mt-auto pt-3 text-xs text-gray-500 dark:text-gray-400">Deleted {{ row.deleted_at | appDate }}</p>
    } @else if (row.created_at) {
    <p class="mt-auto pt-3 text-xs text-gray-500 dark:text-gray-400">Created {{ row.created_at | appDate }}</p>
    }
  </article>
  }
</div>
}
